// import { STAKING_APP_URL } from "@/config";
import { CLIFF_DURATION_DAYS, VESTING_DURATION_DAYS } from "@/config";
import { formatClaimDeadline } from "@/services/claim-window";
import Card from "../Card";
import InfoCircle from "@/assets/info-circle.svg";

const UnlockRulesCard = ({
  dayOneUnlockPerc,
  isClaimClosed = false,
  claimDeadline = null,
}: {
  dayOneUnlockPerc: number;
  isClaimClosed?: boolean;
  claimDeadline?: number | null;
}) => {
  const formattedDeadline = formatClaimDeadline(claimDeadline) ?? "29 May 2026";

  if (dayOneUnlockPerc < 100)
    return (
      <Card className="py-4 flex-col gap-4 !items-start !bg-[#141416]">
        <div className="flex gap-2 items-center font-albert-sans text-white leading-6 text-lg">
          <InfoCircle />
          <span>SPON Reward Unlocking Rules</span>
        </div>
        <ul className="text-sm text-[#9D9D9D] font-inter list-disc pl-6 flex flex-col gap-1">
          {dayOneUnlockPerc > 0 && (
            <li>
              You can currently claim{" "}
              <span className="text-white">
                {Number(dayOneUnlockPerc.toFixed(1))}%
              </span>{" "}
              of your total reward.
            </li>
          )}
          {dayOneUnlockPerc < 100 && dayOneUnlockPerc > 0 && (
            <>
              <li>
                The remaining{" "}
                <span className="text-white">
                  {Number((100 - dayOneUnlockPerc).toFixed(1))}%
                </span>{" "}
                is locked and will become available for claiming starting{" "}
                <span className="text-white">
                  {CLIFF_DURATION_DAYS / 30} months
                </span>{" "}
                from now.
              </li>
              <li>
                After that, the rewards will unlock gradually in a linear manner
                over the following{" "}
                <span className="text-white">
                  {VESTING_DURATION_DAYS / 30} months.
                </span>
              </li>
            </>
          )}
          {dayOneUnlockPerc === 0 && (
            <>
              <li>
                You will be able to start claiming your rewards{" "}
                <span className="text-white">
                  {CLIFF_DURATION_DAYS / 30} months
                </span>{" "}
                from now.
              </li>
              <li>
                After that, the rewards will unlock gradually in a linear manner
                over the following{" "}
                <span className="text-white">
                  {VESTING_DURATION_DAYS / 30} months.
                </span>
              </li>
            </>
          )}
          <li className={isClaimClosed ? "text-[#FF9A93]" : ""}>
            {isClaimClosed ? (
              <>
                The claim period ended on{" "}
                <span className="font-semibold text-white">
                  {formattedDeadline}
                </span>
                , so these rewards can no longer be claimed on-chain.
              </>
            ) : (
              <>
                You should claim all the tokens before{" "}
                <span className="text-white font-semibold">
                  {formattedDeadline}
                </span>
              </>
            )}
          </li>
        </ul>
      </Card>
    );

  return null;
};

export default UnlockRulesCard;
